import React from 'react'
import { Routes, Route } from 'react-router'

import { LazyLoadingMainComponent } from '../components/LazyComponent'

const StandaloneRun = React.lazy(() => import('../containers/tests/StandaloneRun'))

const Standalone = () => {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <LazyLoadingMainComponent>
            <StandaloneRun />
          </LazyLoadingMainComponent>
        }
      />
    </Routes>
  )
}
export default Standalone
